export default __webpack_public_path__ + "static/media/vr_app_login.a5187736.png";